export default __webpack_public_path__ + "static/media/poluvagon.af2c7e27.svg";